'use client';

import * as React from 'react';
import { NetworkStatusBanner, type NetworkStatusBannerProps } from '@axon/ui';

/**
 * NetworkStatusWrapper - Client-side only wrapper for NetworkStatusBanner
 *
 * Prevents SSR hydration mismatch by only rendering after mount.
 * NetworkStatusBanner uses browser APIs (navigator.onLine) which are
 * not available during server-side rendering.
 *
 * RULE 15: Direct JSX usage instead of React.createElement for better webpack compatibility
 */
export function NetworkStatusWrapper(props: NetworkStatusBannerProps): React.ReactElement | null {
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return <NetworkStatusBanner {...props} />;
}

// RULE 15: Named export only for better tree-shaking and module resolution
export type { NetworkStatusBannerProps as NetworkStatusWrapperProps };
